export default "__VITE_ASSET__CFebCaWp__"